export function capitalizeFirstLetter(text) {
    return text.charAt(0).toUpperCase() + text.slice(1);
}
export const truncateText = (text, maxLength) => {
    return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
};
/**
 * Masks other-player usernames: first 3 + last 2 (or first + last if shorter than 6).
 * One `*` per hidden letter. Optional maxLength shrinks asterisks so the visible ends stay.
 */
export function maskUsername(username, maxLength) {
    if (username.length < 2)
        return username;
    const prefixLen = username.length < 6 ? 1 : 3;
    const suffixLen = username.length < 6 ? 1 : 2;
    const prefix = username.slice(0, prefixLen);
    const suffix = username.slice(-suffixLen);
    let hidden = username.length - prefixLen - suffixLen;
    if (maxLength != null) {
        hidden = Math.min(hidden, Math.max(0, maxLength - prefixLen - suffixLen));
    }
    return `${prefix}${'*'.repeat(hidden)}${suffix}`;
}
